import {
    RiNotification3Line,
} from "@remixicon/react";
import React, {
    useCallback,
    useEffect,
    useState,
} from "react";

import { ArticleTag } from "../../__generated__/api";
import Button from "../../components/theme/button/Button";
import Dropdown from "../../components/theme/dropdown/Dropdown";
import Icon from "../../components/theme/icon/Icon";
import ToggleList from "../../components/theme/toggle/ToggleList";
import Styles from "./UpdatesContext.module.scss";

export interface UpdatesSettings {
    selectedTags: string[];
    lastReadDate: number
}
export default function Settings({
    settings,
    onSave,
    tags,
    metricPathPrefix,
}: {
    settings: UpdatesSettings;
    tags: ArticleTag[];
    metricPathPrefix: string[];
    onSave: (props: Partial<UpdatesSettings>) => void;
}) {
    const [shouldShow, setShouldShow] = useState(false);
    const [selectedTags, setSelectedTags] = useState<string[]>(settings.selectedTags);
    useEffect(() => {
        setSelectedTags(settings.selectedTags);
    }, [settings.selectedTags]);

    const save = useCallback(() => {
        setShouldShow(false);
        onSave({ selectedTags });
    }, [selectedTags, onSave]);

    const cancel = useCallback(() => {
        setShouldShow(false);
        setSelectedTags(settings.selectedTags);
    }, [selectedTags, onSave]);

    return (
        <Dropdown drop="up" show={shouldShow} onToggle={() => setShouldShow(!shouldShow)}>
            <Dropdown.Toggle
                variant="outline-gray"
                className="w-100"
                prefixIcon={<RiNotification3Line />}
                size="small"
                onClick={() => setShouldShow(true)}
            >
                Manage Notifications
            </Dropdown.Toggle>
            <Dropdown.Menu className={Styles["settings-container"]}>
                <div className={Styles["settings-header"]}>
                    <div className={Styles["icon-container"]}>
                        <Icon icon={<RiNotification3Line />} size="medium" variant="primary" />
                    </div>
                    <strong className={Styles["settings-title"]}>Turn on notifications</strong>
                    <p className={Styles["settings-description"]}>
                        Always stay up-to-date with the latest system updates!
                    </p>
                </div>
                <div className={Styles["settings-list"]}>
                    <ToggleList
                        allowSelectAll
                        options={tags?.map(tag => ({
                            id: tag.id,
                            label: tag.title,
                        }))}
                        selectedValues={selectedTags}
                        onChange={selected => setSelectedTags(selected.toIdList("id"))}
                    />
                </div>

                <div className={Styles["settings-actions"]}>
                    <Button
                        variant="ghost-blue"
                        size="medium"
                        onClick={cancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        metricPath={[...metricPathPrefix, "save"]}
                        variant="primary"
                        size="medium"
                        onClick={save}
                    >
                        Save
                    </Button>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}
